export enum PaymentStepsEnum {
    SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD',
    ENTER_TOP_UP_AMOUNT = 'ENTER_TOP_UP_AMOUNT',
    ENTER_CARD_DETAILS = 'ENTER_CARD_DETAILS',
    THREE_D_SECURE = 'THREE_D_SECURE',
    BANK_TRANSFER = 'BANK_TRANSFER',
    PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
}